import {graphqlOperation} from '@/plugins/finAmplifyModules'
import {SubscriptionManager} from "@/js/SubscriptionManager"

export default {
  data() {
    return {
      // HINT: each consumer of this mixin must manage it's own instance of the subscription manager
      // otherwise a call to unsubscribeChanges will remove subscription listeners from other consumers too
      subscriptionManager: new SubscriptionManager()
    }
  },
  methods: {
    /**
     * Subscribe a number of given elements for changes.
     *
     * @param elements - a single element or an array containing the objects to subscribe for changes
     * @param subscription - the subscription query with placeholders
     * @param paramFunction - a function to be called for each element to replace the placeholders
     * @param handleSubscription - the method to be called on subscription change
     * @param authMode - set either 'AWS_IAM' or 'AMAZON_COGNITO_USER_POOLS' (auth vuex store publicQueryAuthMode can
     * be used), or leave empty
     */
    subscribeToChanges(elements, subscription, paramFunction, handleSubscription, authMode) {
      this.subscriptionManager.addFromList(
        elements,
        (item) => {
          return {
            ...graphqlOperation(subscription, paramFunction(item)),
            authMode: authMode
          }
        },
        handleSubscription
      )
    },
    /**
     * Manually unregister all subscriptions, otherwise done in beforeDestroy hook.
     */
    unsubscribeChanges() {
      this.subscriptionManager.clear()
    },
  },
  beforeDestroy() {
    this.unsubscribeChanges()
  }
}
